import React, { useCallback, useEffect, useState } from 'react';
import { ulid } from 'ulid';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Storage } from 'aws-amplify';
import { Grid, Typography, Button as ButtonUI } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import UpdateEventForm from './UpdateEventForm';
import { Loading, Layout, UserNavbar } from '../../../../components';
import * as EventActions from '../../../../core/events/action';
import * as VenueActions from '../../../../core/venues/action';
import { APP_ROUTES } from '../../../../constants/app-routes';
import Banner from '../../venues/components/Banner/Banner';
import '../styles.scss';

export default function UpdateEvent() {
  const [title, setTitle] = useState('');
  const [loadingUpload, setLoadingUpload] = useState(false);
  const { currentVenue, currentVenuePictures, principalBanner } = useSelector(
    (store) => store.venues,
  );
  const { successMessage, failedMessage } = useSelector((store) => store.events);

  const { loading } = useSelector((store) => store.events);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const CustomizedSwal = withReactContent(Swal);
  const { user, loading: userLoading } = useSelector((store) => store.users);
  const onLoadBannerFromAllVenuePhotos = useCallback(async () => {
    const [FirstPicture] = currentVenuePictures;
    const signedURL = await Storage.get(FirstPicture.key);
    dispatch(VenueActions.setPrincipalBannerVenue(signedURL));
  }, [currentVenuePictures, dispatch]);

  const onLoadBannerFromVenueBanner = useCallback(
    async (photo) => {
      const signedURL = await Storage.get(photo);
      console.log(signedURL);
      dispatch(VenueActions.setPrincipalBannerVenue(signedURL));
    },
    [dispatch],
  );

  const uploadPictures = useCallback(
    async (pics) => {
      const fileUploaded = [];
      try {
        setLoadingUpload(true);
        await Promise.all(
          pics.map(async ({ file }) => {
            const fileName = `${ulid()}.${file.name.split('.')[1]}`;
            const ready = await Storage.put(`VENUES/${user.id}/${fileName}`, file, {
              contentType: file.type,
            });
            fileUploaded.push({ ...ready, fileName });
          }),
        );
      } catch (error) {
        console.error('Error uploading file: ', error);
      }
      return fileUploaded;
    },
    [user?.id],
  );

  const getModalSuccess = useCallback(
    (name, description) => {
      CustomizedSwal.fire({
        title: <strong>{name}</strong>,
        text: 'Event updated successful!',
        icon: 'success',
      });
    },
    [CustomizedSwal],
  );

  const getModalFailed = useCallback(
    (name, description) => {
      CustomizedSwal.fire({
        title: <strong>{name}</strong>,
        text: description,
        icon: 'error',
      });
    },
    [CustomizedSwal],
  );

  useEffect(() => {
    if (currentVenue?.banner) onLoadBannerFromVenueBanner(currentVenue.banner);
    else if (currentVenuePictures.length > 0)
      onLoadBannerFromAllVenuePhotos(currentVenuePictures[0]);
  }, [
    currentVenue?.banner,
    currentVenuePictures,
    onLoadBannerFromAllVenuePhotos,
    onLoadBannerFromVenueBanner,
  ]);

  useEffect(() => {
    if (successMessage) getModalSuccess('Event Updated');
    else if (failedMessage) getModalFailed('Failed update', failedMessage);

    if (currentVenue) setTitle(currentVenue.name);
  }, [currentVenue, failedMessage, getModalFailed, getModalSuccess, successMessage]);

  const onUpdateEvent = async (event) => {
    const fileUploaded = await uploadPictures(event.photo);
    const updatedEvent = { ...event };
    updatedEvent.photo = fileUploaded;
    dispatch(EventActions.updateEvent(updatedEvent, navigate));
  };

  return (
    <Layout>
      {loading && <Loading />}
      <UserNavbar />
      <Banner picture={principalBanner} />
      <Grid container justifyContent="center">
        <ButtonUI
          size="large"
          color="info"
          style={{ marginTop: 25 }}
          onClick={() => navigate(APP_ROUTES.DASHBOARD)}>
          <ArrowBackIosIcon />
        </ButtonUI>
        <Typography variant="h3" color="#EE7B57" fontWeight="bold" marginTop={5} align="center">
          {title}
        </Typography>
      </Grid>
      <UpdateEventForm onUpdateEvent={onUpdateEvent} />,
    </Layout>
  );
}
